// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/builds/msfund/msvc-web/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/builds/msfund/msvc-web/src/layouts/UserLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "login",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/builds/msfund/msvc-web/src/pages/user/login'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "binding",
        "path": "/user/binding",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__Binding' */'/builds/msfund/msvc-web/src/pages/user/Binding'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/builds/msfund/msvc-web/src/layouts/BasicLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "name": "首页",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Loading' */'/builds/msfund/msvc-web/src/pages/Home/Loading'), loading: LoadingComponent}),
        "authority": "/home",
        "code": "1",
        "exact": true
      },
      {
        "path": "/home/kanban",
        "name": "我的看板",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Kanban' */'/builds/msfund/msvc-web/src/pages/Home/Kanban'), loading: LoadingComponent}),
        "code": "101",
        "exact": true
      },
      {
        "path": "/home/news",
        "name": "消息列表",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__News' */'/builds/msfund/msvc-web/src/pages/News'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/home/mySpace/personalNotes/:tab",
        "name": "个人笔记",
        "authority": "/home/mySpace",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__MySpace__PersonalNotes' */'/builds/msfund/msvc-web/src/pages/Home/MySpace/PersonalNotes'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/home/mySpace",
        "name": "我的空间",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__MySpace' */'/builds/msfund/msvc-web/src/pages/Home/MySpace'), loading: LoadingComponent}),
        "code": "102",
        "exact": true
      },
      {
        "path": "/home/mySpace/myTask",
        "name": "我的任务",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__MySpace__Task' */'/builds/msfund/msvc-web/src/pages/Home/MySpace/Task'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "102"
        ],
        "exact": true
      },
      {
        "path": "/home/mySpace/task/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Operate__Task__TaskDetail' */'/builds/msfund/msvc-web/src/pages/Workbench/Operate/Task/TaskDetail'), loading: LoadingComponent}),
        "code": [
          "102"
        ],
        "exact": true
      },
      {
        "path": "/home/mySpace/notes/detail/:id",
        "name": "笔记",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__MySpace__Notes__Detail' */'/builds/msfund/msvc-web/src/pages/Home/MySpace/Notes/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "102"
        ],
        "exact": true
      },
      {
        "path": "/home/mySpace/notes/detail/:id/edit",
        "name": "笔记",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__MySpace__Notes__Detail__Edit' */'/builds/msfund/msvc-web/src/pages/Home/MySpace/Notes/Detail/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "102"
        ],
        "exact": true
      },
      {
        "path": "/home/topicSquare",
        "name": "我的小组",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__TopicSquare' */'/builds/msfund/msvc-web/src/pages/Home/TopicSquare'), loading: LoadingComponent}),
        "code": "104",
        "exact": true
      },
      {
        "path": "/home/topicSquare/detail/:group_id/:topic_id",
        "name": "话题详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__TopicSquare__Detail' */'/builds/msfund/msvc-web/src/pages/Home/TopicSquare/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "104"
        ],
        "exact": true
      },
      {
        "path": "/home/topicSquare/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "104"
        ],
        "exact": true
      },
      {
        "path": "/home/todo",
        "name": "我的待办",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Todo' */'/builds/msfund/msvc-web/src/pages/Home/Todo'), loading: LoadingComponent}),
        "code": "105",
        "exact": true
      },
      {
        "path": "/home/search",
        "name": "全局搜索",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__GlobalSearch' */'/builds/msfund/msvc-web/src/pages/Home/GlobalSearch'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/home/meeting_management",
        "name": "会议管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Meeting__MeetingList' */'/builds/msfund/msvc-web/src/pages/Home/Meeting/MeetingList'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "106",
        "exact": true
      },
      {
        "path": "/home/meeting_management/detail/:id",
        "name": "Meeting详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Meeting__MeetingDetail' */'/builds/msfund/msvc-web/src/pages/Home/Meeting/MeetingDetail'), loading: LoadingComponent}),
        "code": [
          "106"
        ],
        "exact": true
      },
      {
        "path": "/ai_meeting",
        "name": "ai会议",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiMeeting__AllAiMeeting' */'/builds/msfund/msvc-web/src/pages/aiMeeting/AllAiMeeting'), loading: LoadingComponent}),
        "code": "13",
        "exact": true
      },
      {
        "path": "/ai_meeting/all_meeting",
        "name": "所有会议",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiMeeting__AllAiMeeting' */'/builds/msfund/msvc-web/src/pages/aiMeeting/AllAiMeeting'), loading: LoadingComponent}),
        "code": "1301",
        "exact": true
      },
      {
        "path": "/ai_meeting/all_meeting/meeting/:id",
        "name": "会议详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiMeeting__AiMeetingDetail' */'/builds/msfund/msvc-web/src/pages/aiMeeting/AiMeetingDetail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench",
        "name": "工作台",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__PreLeads__index' */'/builds/msfund/msvc-web/src/pages/Workbench/PreLeads/index'), loading: LoadingComponent}),
        "code": "2",
        "exact": true
      },
      {
        "path": "/workbench/pre_leads",
        "name": "中台Pre-Leads",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__PreLeads__index' */'/builds/msfund/msvc-web/src/pages/Workbench/PreLeads/index'), loading: LoadingComponent}),
        "code": "209",
        "exact": true
      },
      {
        "path": "/workbench/irmeeting",
        "name": "IR Meeting",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__IrMeeting__IrMeetingList' */'/builds/msfund/msvc-web/src/pages/Workbench/IrMeeting/IrMeetingList'), loading: LoadingComponent}),
        "code": "217",
        "exact": true
      },
      {
        "path": "/workbench/pre_leads/detail",
        "name": "中台Pre-Leads",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__PreLeads__Detail' */'/builds/msfund/msvc-web/src/pages/Workbench/PreLeads/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "209"
        ],
        "exact": true
      },
      {
        "path": "/workbench/pre_leads/list",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__PreLeads__List' */'/builds/msfund/msvc-web/src/pages/Workbench/PreLeads/List'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "209"
        ],
        "exact": true
      },
      {
        "path": "/workbench/leads",
        "name": "中台Leads",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__index' */'/builds/msfund/msvc-web/src/pages/Leads/index'), loading: LoadingComponent}),
        "code": "201",
        "exact": true
      },
      {
        "path": "/workbench/leads/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/workbench/operate",
        "name": "中台运营",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Operate__index' */'/builds/msfund/msvc-web/src/pages/Workbench/Operate/index'), loading: LoadingComponent}),
        "code": "202",
        "exact": true
      },
      {
        "path": "/workbench/operate/System/mergerProject",
        "name": "合并项目",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Operate__System__MergerProject' */'/builds/msfund/msvc-web/src/pages/Workbench/Operate/System/MergerProject'), loading: LoadingComponent}),
        "code": "202003",
        "exact": true
      },
      {
        "path": "/workbench/operate/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/operate/task/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Operate__Task__TaskDetail' */'/builds/msfund/msvc-web/src/pages/Workbench/Operate/Task/TaskDetail'), loading: LoadingComponent}),
        "code": [
          "202",
          "102"
        ],
        "exact": true
      },
      {
        "path": "/workbench/log/detail/writeLog/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/workbench/leads/import",
        "name": "导入项目",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__import' */'/builds/msfund/msvc-web/src/pages/Leads/import'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "201002",
        "exact": true
      },
      {
        "path": "/workbench/log",
        "name": "我的Log/Proposal",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Log__index' */'/builds/msfund/msvc-web/src/pages/Workbench/Log/index'), loading: LoadingComponent}),
        "code": "203",
        "exact": true
      },
      {
        "path": "/workbench/log/newProject",
        "name": "新建项目",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Log__NewProject' */'/builds/msfund/msvc-web/src/pages/Workbench/Log/NewProject'), loading: LoadingComponent}),
        "code": "203001",
        "exact": true
      },
      {
        "path": "/workbench/log/newProposal",
        "name": "新建Proposal",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Log__NewProposal' */'/builds/msfund/msvc-web/src/pages/Workbench/Log/NewProposal'), loading: LoadingComponent}),
        "code": "203002",
        "exact": true
      },
      {
        "path": "/workbench/log/writeLog/:id",
        "name": "写Log",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Log__WriteLog' */'/builds/msfund/msvc-web/src/pages/Workbench/Log/WriteLog'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/log/writeProposal/:id",
        "name": "写Proposal",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Log__WriteProposal' */'/builds/msfund/msvc-web/src/pages/Workbench/Log/WriteProposal'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/memo",
        "name": "我的Memo",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Memo' */'/builds/msfund/msvc-web/src/pages/Workbench/Memo'), loading: LoadingComponent}),
        "code": "204",
        "exact": true
      },
      {
        "path": "/workbench/memo/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/memo/write/:id",
        "name": "写Memo",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Memo__writeMemo' */'/builds/msfund/msvc-web/src/pages/Workbench/Memo/writeMemo'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/memo/write/notFollow/:id",
        "name": "写Memo",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Memo__notJoinMemo' */'/builds/msfund/msvc-web/src/pages/Workbench/Memo/notJoinMemo'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/tc/write/:id",
        "name": "写TC",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Tc__WriteTc' */'/builds/msfund/msvc-web/src/pages/Workbench/Tc/WriteTc'), loading: LoadingComponent}),
        "code": "1001006",
        "exact": true
      },
      {
        "path": "/workbench/memo/record/:id",
        "name": "录入Memo",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Memo__recordMemo' */'/builds/msfund/msvc-web/src/pages/Workbench/Memo/recordMemo'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/memo/write/exit/:id",
        "name": "退出/回款Memo",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Memo__exitMemo' */'/builds/msfund/msvc-web/src/pages/Workbench/Memo/exitMemo'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/ts",
        "name": "我的Pipeline",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Ts' */'/builds/msfund/msvc-web/src/pages/Workbench/Ts'), loading: LoadingComponent}),
        "code": "205",
        "exact": true
      },
      {
        "path": "/workbench/ts/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/portfolio",
        "name": "我的Portfolio",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio'), loading: LoadingComponent}),
        "code": "206",
        "exact": true
      },
      {
        "path": "/workbench/portfolio/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/portfolioreview",
        "name": "我的Portfolio Review",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__review' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/review'), loading: LoadingComponent}),
        "code": "215",
        "exact": true
      },
      {
        "path": "/workbench/allportfolioreview",
        "name": "所有Portfolio Review",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__allReview' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/allReview'), loading: LoadingComponent}),
        "code": "216",
        "exact": true
      },
      {
        "path": "/workbench/portfolioreview/detail/:id",
        "name": "详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/portfolioreview/write/:projectId/:id",
        "name": "写portfolioreview",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__addPortfolio' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/addPortfolio'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/approvalProjects",
        "name": "待审批项目",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__ApprovalProjects' */'/builds/msfund/msvc-web/src/pages/Workbench/ApprovalProjects'), loading: LoadingComponent}),
        "code": "207",
        "exact": true
      },
      {
        "path": "/workbench/voteProjects",
        "name": "待投票项目",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__VoteProjects' */'/builds/msfund/msvc-web/src/pages/Workbench/VoteProjects'), loading: LoadingComponent}),
        "code": "208",
        "exact": true
      },
      {
        "path": "/workbench/approvalProjects/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/voteProjects/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/backstage",
        "name": "后台Portfolio",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Backstage__portfolio' */'/builds/msfund/msvc-web/src/pages/Workbench/Backstage/portfolio'), loading: LoadingComponent}),
        "code": "210",
        "exact": true
      },
      {
        "path": "/workbench/backstage/portfolio/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/partner",
        "name": "合伙人Portfolio",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Partner__portfolio' */'/builds/msfund/msvc-web/src/pages/Workbench/Partner/portfolio'), loading: LoadingComponent}),
        "code": "211",
        "exact": true
      },
      {
        "path": "/workbench/partner/portfolio/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/backstagepipeline",
        "name": "后台Pipeline",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Backstage__pipeline' */'/builds/msfund/msvc-web/src/pages/Workbench/Backstage/pipeline'), loading: LoadingComponent}),
        "code": "212",
        "exact": true
      },
      {
        "path": "/workbench/backstagepipeline/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/partnerpipeline",
        "name": "合伙人Pipeline",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Partner__pipeline' */'/builds/msfund/msvc-web/src/pages/Workbench/Partner/pipeline'), loading: LoadingComponent}),
        "code": "213",
        "exact": true
      },
      {
        "path": "/workbench/partnerpipeline/detail/:id",
        "name": "项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/backoperate",
        "name": "后台运营",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__BackOperate__index' */'/builds/msfund/msvc-web/src/pages/Workbench/BackOperate/index'), loading: LoadingComponent}),
        "code": "214",
        "exact": true
      },
      {
        "path": "/workbench/backoperate/detail/:id",
        "name": "后台运营-项目详情",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/workbench/irmeeting/from/:id",
        "name": "写IR Meeting",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__IrMeeting__MeetingEdit' */'/builds/msfund/msvc-web/src/pages/Workbench/IrMeeting/MeetingEdit'), loading: LoadingComponent}),
        "code": [
          "217"
        ],
        "exact": true
      },
      {
        "path": "/workbench/irmeeting/detail/:id",
        "name": "Meeting详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__IrMeeting__MeetingDetail' */'/builds/msfund/msvc-web/src/pages/Workbench/IrMeeting/MeetingDetail'), loading: LoadingComponent}),
        "code": [
          "217"
        ],
        "exact": true
      },
      {
        "path": "/workbench/investorInfo",
        "name": "投资人信息",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Investor__InvestorList' */'/builds/msfund/msvc-web/src/pages/Workbench/Investor/InvestorList'), loading: LoadingComponent}),
        "code": "218",
        "exact": true
      },
      {
        "path": "/workbench/investorInfo/from/:id",
        "name": "写投资人信息",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Investor__InvestorEdit' */'/builds/msfund/msvc-web/src/pages/Workbench/Investor/InvestorEdit'), loading: LoadingComponent}),
        "code": [
          "218"
        ],
        "exact": true
      },
      {
        "path": "/workbench/investorInfo/:id",
        "name": "投资人信息详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Investor__Detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Investor/Detail'), loading: LoadingComponent}),
        "code": [
          "218"
        ],
        "exact": true
      },
      {
        "path": "/workbench/contact",
        "name": "联系人信息",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Contact' */'/builds/msfund/msvc-web/src/pages/Workbench/Contact'), loading: LoadingComponent}),
        "code": "219",
        "exact": true
      },
      {
        "path": "/deal",
        "name": "项目",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__Pool' */'/builds/msfund/msvc-web/src/pages/Deal/Pool'), loading: LoadingComponent}),
        "code": "3",
        "exact": true
      },
      {
        "path": "/deal/pool",
        "name": "Deal Pool",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__Pool' */'/builds/msfund/msvc-web/src/pages/Deal/Pool'), loading: LoadingComponent}),
        "code": "301",
        "exact": true
      },
      {
        "path": "/deal/log",
        "name": "Deal Logs",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__Log' */'/builds/msfund/msvc-web/src/pages/Deal/Log'), loading: LoadingComponent}),
        "code": "302",
        "exact": true
      },
      {
        "path": "/deal/flows",
        "name": "Deal Flows",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__Flows' */'/builds/msfund/msvc-web/src/pages/Deal/Flows'), loading: LoadingComponent}),
        "code": "303",
        "exact": true
      },
      {
        "path": "/deal/portfolio",
        "name": "Portfolio",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__Portfolio' */'/builds/msfund/msvc-web/src/pages/Deal/Portfolio'), loading: LoadingComponent}),
        "code": "304",
        "exact": true
      },
      {
        "path": "/deal/pool/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/deal/log/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/deal/flows/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/deal/portfolio/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Workbench__Portfolio__detail' */'/builds/msfund/msvc-web/src/pages/Workbench/Portfolio/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/deal/stock_memo",
        "name": "二级Memo",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__SubMemo' */'/builds/msfund/msvc-web/src/pages/Deal/SubMemo'), loading: LoadingComponent}),
        "code": "305",
        "exact": true
      },
      {
        "path": "/deal/stock_memo/edit/:id",
        "name": "编辑二级Memo",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__SubMemo__SubMemoEdit' */'/builds/msfund/msvc-web/src/pages/Deal/SubMemo/SubMemoEdit'), loading: LoadingComponent}),
        "code": [
          "305"
        ],
        "exact": true
      },
      {
        "path": "/deal/stock_memo/detail/:id",
        "name": "二级Memo详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Deal__SubMemo__SubMemoDetail' */'/builds/msfund/msvc-web/src/pages/Deal/SubMemo/SubMemoDetail'), loading: LoadingComponent}),
        "code": [
          "305"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo",
        "name": "公司资料",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__TrackData' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/TrackData'), loading: LoadingComponent}),
        "code": "4",
        "exact": true
      },
      {
        "path": "/companyInfo/trackData",
        "name": "主赛道资料",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__TrackData' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/TrackData'), loading: LoadingComponent}),
        "code": "401",
        "exact": true
      },
      {
        "path": "/companyInfo/trackData/content/:id",
        "name": "赛道名称",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__TrackData__Content' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/TrackData/Content'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "401"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/trackData/detail/:id",
        "name": "项目详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Leads__detail' */'/builds/msfund/msvc-web/src/pages/Leads/detail'), loading: LoadingComponent}),
        "authority": "/companyInfo/trackData",
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/researchReport",
        "name": "中台报告",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__ResearchReport' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/ResearchReport'), loading: LoadingComponent}),
        "code": "402",
        "exact": true
      },
      {
        "path": "/companyInfo/researchReport/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__ResearchReport__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/ResearchReport/list'), loading: LoadingComponent}),
        "code": [
          "402"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/researchReport/:categoryId/detail/:id",
        "name": "报告详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__ResearchReport__detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/ResearchReport/detail'), loading: LoadingComponent}),
        "code": [
          "402"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/researchReport/:categoryId/edit",
        "name": "新建文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__ResearchReport__edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/ResearchReport/edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "402002",
        "exact": true
      },
      {
        "path": "/companyInfo/minutesMeeting",
        "name": "会议纪要",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__MinutesMeeting' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/MinutesMeeting'), loading: LoadingComponent}),
        "code": "403",
        "exact": true
      },
      {
        "path": "/companyInfo/minutesMeeting/:id",
        "name": "会议纪要列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__MinutesMeeting__List' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/MinutesMeeting/List'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "403"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/minutesMeeting/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__MinutesMeeting__Detail__index' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/MinutesMeeting/Detail/index'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "403"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/minutesMeeting/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__MinutesMeeting__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/MinutesMeeting/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "403002",
        "exact": true
      },
      {
        "path": "/companyInfo/humanResources",
        "name": "人力资源",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__HumanResources' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/HumanResources'), loading: LoadingComponent}),
        "code": "405",
        "exact": true
      },
      {
        "path": "/companyInfo/humanResources/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__HumanResources__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/HumanResources/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "405"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/humanResources/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__HumanResources__detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/HumanResources/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "405"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/humanResources/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__HumanResources__edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/HumanResources/edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/publicRelations",
        "name": "公共关系",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PublicRelations' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PublicRelations'), loading: LoadingComponent}),
        "code": "406",
        "exact": true
      },
      {
        "path": "/companyInfo/publicRelations/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PublicRelations__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PublicRelations/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "406"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/publicRelations/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PublicRelations__detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PublicRelations/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "406"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/publicRelations/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PublicRelations__edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PublicRelations/edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/projectDocuments",
        "name": "项目文件",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__ProjectDocuments' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/ProjectDocuments'), loading: LoadingComponent}),
        "code": "407",
        "exact": true
      },
      {
        "path": "/companyInfo/companyDocuments",
        "name": "公司全体",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__CompanyDocuments' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/CompanyDocuments'), loading: LoadingComponent}),
        "code": "408",
        "exact": true
      },
      {
        "path": "/companyInfo/companyDocuments/:id",
        "name": "列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__CompanyDocuments__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/CompanyDocuments/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "408"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/companyDocuments/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__CompanyDocuments__Detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/CompanyDocuments/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "408"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/companyDocuments/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__CompanyDocuments__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/CompanyDocuments/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/backstageDocuments",
        "name": "后台文件",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__BackstageDocuments' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/BackstageDocuments'), loading: LoadingComponent}),
        "code": "412",
        "exact": true
      },
      {
        "path": "/companyInfo/backstageDocuments/:id",
        "name": "列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__BackstageDocuments__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/BackstageDocuments/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "412"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/backstageDocuments/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__BackstageDocuments__Detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/BackstageDocuments/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "412"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/backstageDocuments/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__BackstageDocuments__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/BackstageDocuments/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/investmentPlanning",
        "name": "运营体系",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__InvestmentPlanning' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/InvestmentPlanning'), loading: LoadingComponent}),
        "code": "409",
        "exact": true
      },
      {
        "path": "/companyInfo/investmentPlanning/:id",
        "name": "列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__InvestmentPlanning__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/InvestmentPlanning/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "409"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/investmentPlanning/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__InvestmentPlanning__Detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/InvestmentPlanning/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "409"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/investmentPlanning/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__InvestmentPlanning__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/InvestmentPlanning/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/partnerSharing",
        "name": "合伙人分享",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PartnerSharing' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PartnerSharing'), loading: LoadingComponent}),
        "code": "410",
        "exact": true
      },
      {
        "path": "/companyInfo/partnerSharing/:id",
        "name": "列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PartnerSharing__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PartnerSharing/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "410"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/partnerSharing/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PartnerSharing__Detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PartnerSharing/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "410"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/partnerSharing/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__PartnerSharing__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/PartnerSharing/Edit'), loading: LoadingComponent}),
        "authority": "/companyInfo/partnerSharing",
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/companyInfo/workflowSpecification",
        "name": "工作流程和规范",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__WorkflowSpecification' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/WorkflowSpecification'), loading: LoadingComponent}),
        "code": "411",
        "exact": true
      },
      {
        "path": "/companyInfo/workflowSpecification/:id",
        "name": "列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__WorkflowSpecification__list' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/WorkflowSpecification/list'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "411"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/workflowSpecification/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__WorkflowSpecification__Detail' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/WorkflowSpecification/Detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "411"
        ],
        "exact": true
      },
      {
        "path": "/companyInfo/workflowSpecification/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyInfo__WorkflowSpecification__Edit' */'/builds/msfund/msvc-web/src/pages/CompanyInfo/WorkflowSpecification/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/meetingDocument/:id",
        "name": "会议文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__index' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/index'), loading: LoadingComponent}),
        "authority": "/meetingDocument",
        "subRoute": [
          {
            "path": "/meetingDocument/8",
            "name": "Research/Sharing",
            "code": "901"
          },
          {
            "path": "/meetingDocument/10",
            "name": "年会",
            "code": "902"
          },
          {
            "path": "/meetingDocument/701",
            "name": "周会/双周会",
            "code": "903"
          },
          {
            "path": "/meetingDocument/5",
            "name": "Memo会议",
            "code": "904"
          },
          {
            "path": "/meetingDocument/702",
            "name": "Portfolio Review会议",
            "code": "911"
          },
          {
            "path": "/meetingDocument/12",
            "name": "主题会议",
            "code": "905"
          },
          {
            "path": "/meetingDocument/1001",
            "name": "管理层会议",
            "code": "906"
          },
          {
            "path": "/meetingDocument/3",
            "name": "季会-Archive",
            "code": "907"
          }
        ],
        "exact": true
      },
      {
        "path": "/meetingDocument/:categoryId/create",
        "name": "创建会议纪要",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__Edit' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "900002",
        "exact": true
      },
      {
        "path": "/meetingDocument/:categoryId/edit",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__Edit' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/Edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "900003",
        "exact": true
      },
      {
        "path": "/meetingDocument/:categoryId/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__Detail__index' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/Detail/index'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "9"
        ],
        "exact": true
      },
      {
        "path": "/meetingDocument/document/:categoryId/edit",
        "name": "周会/双周会-新建文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__MeetingMinutesDocumentEdit' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/MeetingMinutesDocumentEdit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "900003",
        "exact": true
      },
      {
        "path": "/meetingDocument/document/:categoryId/detail/:id",
        "name": "周会/双周会-详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__MeetingMinutesDocumentDetail' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/MeetingMinutesDocumentDetail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "9"
        ],
        "exact": true
      },
      {
        "path": "/meetingDocument/biweek/:categoryId/detail/:id",
        "name": "周会/双周会-详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__MeetingMinutesDocumentDetail' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/MeetingMinutesDocumentDetail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "9"
        ],
        "exact": true
      },
      {
        "path": "/meetingDocument/tcDocument/:id",
        "name": "TC文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__tcList' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/tcList'), loading: LoadingComponent}),
        "authority": "/meetingDocument/tcDocument/202",
        "code": "910",
        "exact": true
      },
      {
        "path": "/meetingDocument/tcDocument/:categoryId/edit",
        "name": "TC文档-新建文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__tcEdit' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/tcEdit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "910006",
        "exact": true
      },
      {
        "path": "/meetingDocument/tcDocument/:categoryId/detail/:id",
        "name": "TC文档-详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__tcDetail' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/tcDetail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "910"
        ],
        "exact": true
      },
      {
        "path": "/meetingDocument/shareReport/:id",
        "name": "报告分享",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__list' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/list'), loading: LoadingComponent}),
        "authority": "/meetingDocument/shareReport/7",
        "code": "909",
        "exact": true
      },
      {
        "path": "/meetingDocument/shareReport/:categoryId/edit",
        "name": "报告分享-新建文档",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__edit' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/edit'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": "909006",
        "exact": true
      },
      {
        "path": "/meetingDocument/shareReport/:categoryId/detail/:id",
        "name": "报告分享-详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MeetingDocument__ResearchReport__detail' */'/builds/msfund/msvc-web/src/pages/MeetingDocument/ResearchReport/detail'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "909"
        ],
        "exact": true
      },
      {
        "path": "/teamManagement",
        "name": "团队管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManagement__team' */'/builds/msfund/msvc-web/src/pages/TeamManagement/team'), loading: LoadingComponent}),
        "code": "5",
        "exact": true
      },
      {
        "path": "/teamManagement/team",
        "name": "团队管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManagement__team' */'/builds/msfund/msvc-web/src/pages/TeamManagement/team'), loading: LoadingComponent}),
        "code": "501",
        "exact": true
      },
      {
        "path": "/teamManagement/user",
        "name": "成员管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManagement__user' */'/builds/msfund/msvc-web/src/pages/TeamManagement/user'), loading: LoadingComponent}),
        "code": "502",
        "exact": true
      },
      {
        "path": "/teamManagement/dashboardTeam",
        "name": "中台看板团队",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManagement__DashboardTeam' */'/builds/msfund/msvc-web/src/pages/TeamManagement/DashboardTeam'), loading: LoadingComponent}),
        "code": "503",
        "exact": true
      },
      {
        "path": "/sysManagement",
        "name": "角色权限管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysManagement__role' */'/builds/msfund/msvc-web/src/pages/SysManagement/role'), loading: LoadingComponent}),
        "code": "6",
        "exact": true
      },
      {
        "path": "/sysManagement/role",
        "name": "角色权限管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysManagement__role' */'/builds/msfund/msvc-web/src/pages/SysManagement/role'), loading: LoadingComponent}),
        "code": "601",
        "exact": true
      },
      {
        "path": "/sysManagement/user",
        "name": "系统账号管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysManagement__user' */'/builds/msfund/msvc-web/src/pages/SysManagement/user'), loading: LoadingComponent}),
        "code": "602",
        "exact": true
      },
      {
        "path": "/sysConfig",
        "name": "系统配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__channelGroup' */'/builds/msfund/msvc-web/src/pages/SysConfig/channelGroup'), loading: LoadingComponent}),
        "code": "7",
        "exact": true
      },
      {
        "path": "/sysConfig/channelGroup",
        "name": "主赛道配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__channelGroup' */'/builds/msfund/msvc-web/src/pages/SysConfig/channelGroup'), loading: LoadingComponent}),
        "code": "701",
        "exact": true
      },
      {
        "path": "/sysConfig/channelGroup/:id",
        "name": "赛道明细",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__channel' */'/builds/msfund/msvc-web/src/pages/SysConfig/channel'), loading: LoadingComponent}),
        "hideInMenu": true,
        "code": [
          "701"
        ],
        "exact": true
      },
      {
        "path": "/sysConfig/data",
        "name": "数组配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__data' */'/builds/msfund/msvc-web/src/pages/SysConfig/data'), loading: LoadingComponent}),
        "code": "702",
        "exact": true
      },
      {
        "path": "/sysConfig/data/:config_code",
        "name": "数组明细",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__data__list' */'/builds/msfund/msvc-web/src/pages/SysConfig/data/list'), loading: LoadingComponent}),
        "code": [
          "702"
        ],
        "exact": true
      },
      {
        "path": "/sysConfig/fund",
        "name": "Fund配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__fund' */'/builds/msfund/msvc-web/src/pages/SysConfig/fund'), loading: LoadingComponent}),
        "code": "703",
        "exact": true
      },
      {
        "path": "/sysConfig/vote_scheme",
        "name": "投票配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__VoteSchemeConfig' */'/builds/msfund/msvc-web/src/pages/SysConfig/VoteSchemeConfig'), loading: LoadingComponent}),
        "code": "704",
        "exact": true
      },
      {
        "path": "/sysConfig/vote_scheme/voter/:id",
        "name": "投票人配置",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__VoteSchemeConfig__VoteSchemeVoterDetail' */'/builds/msfund/msvc-web/src/pages/SysConfig/VoteSchemeConfig/VoteSchemeVoterDetail'), loading: LoadingComponent}),
        "code": [
          "704"
        ],
        "exact": true
      },
      {
        "path": "/sysConfig/vote_scheme/scheme/:id",
        "name": "投票人配置",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__VoteSchemeConfig__VoteSchemeConfigDetail' */'/builds/msfund/msvc-web/src/pages/SysConfig/VoteSchemeConfig/VoteSchemeConfigDetail'), loading: LoadingComponent}),
        "code": [
          "704"
        ],
        "exact": true
      },
      {
        "path": "/sysConfig/product_group",
        "name": "产品-Thesis配置",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__product__ProductGroup' */'/builds/msfund/msvc-web/src/pages/SysConfig/product/ProductGroup'), loading: LoadingComponent}),
        "code": "705",
        "exact": true
      },
      {
        "path": "/sysConfig/product_group/:id",
        "name": "产品Thesis配置",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SysConfig__product__ProductGroupDetail' */'/builds/msfund/msvc-web/src/pages/SysConfig/product/ProductGroupDetail'), loading: LoadingComponent}),
        "code": [
          "705"
        ],
        "exact": true
      },
      {
        "path": "/hr_management",
        "name": "人事管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeDashboard' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeDashboard'), loading: LoadingComponent}),
        "code": "11",
        "exact": true
      },
      {
        "path": "/hr_management/employee_archive",
        "name": "员工档案",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeArchive' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeArchive'), loading: LoadingComponent}),
        "code": "1101",
        "exact": true
      },
      {
        "path": "/hr_management/employee_archive/create",
        "name": "创建",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeArchive__EditArchive' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeArchive/EditArchive'), loading: LoadingComponent}),
        "code": "1101002",
        "exact": true
      },
      {
        "path": "/hr_management/employee_archive/edit/:id",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeArchive__EditArchive' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeArchive/EditArchive'), loading: LoadingComponent}),
        "code": "1101003",
        "exact": true
      },
      {
        "path": "/hr_management/employee_archive/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeArchive__ArchiveDetail' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeArchive/ArchiveDetail'), loading: LoadingComponent}),
        "code": [
          "1101"
        ],
        "exact": true
      },
      {
        "path": "/hr_management/employee_event",
        "name": "员工事件",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeEvent' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeEvent'), loading: LoadingComponent}),
        "code": "1102",
        "exact": true
      },
      {
        "path": "/hr_management/employee_event/create",
        "name": "创建",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeEvent__EditEvent' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeEvent/EditEvent'), loading: LoadingComponent}),
        "code": "1102002",
        "exact": true
      },
      {
        "path": "/hr_management/employee_event/edit/:id",
        "name": "编辑",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeEvent__EditEvent' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeEvent/EditEvent'), loading: LoadingComponent}),
        "code": "1102003",
        "exact": true
      },
      {
        "path": "/hr_management/employee_event/detail/:id",
        "name": "详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeEvent__EventDetail' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeEvent/EventDetail'), loading: LoadingComponent}),
        "code": [
          "1102"
        ],
        "exact": true
      },
      {
        "path": "/hr_management/employee_dashboard",
        "name": "DashBoard",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeDashboard' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeDashboard'), loading: LoadingComponent}),
        "code": "1103",
        "exact": true
      },
      {
        "path": "/performance_management",
        "name": "绩效管理",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__PerformanceDetail' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/PerformanceDetail'), loading: LoadingComponent}),
        "code": "12",
        "exact": true
      },
      {
        "path": "/performance_management/detail/:id",
        "name": "绩效详情",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__PerformanceDetail' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/PerformanceDetail'), loading: LoadingComponent}),
        "code": [
          "1202",
          "1203",
          "1204"
        ],
        "exact": true
      },
      {
        "path": "/performance_management/performance_dashboard",
        "name": "DashBoard",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__PerformanceDashboard' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/PerformanceDashboard'), loading: LoadingComponent}),
        "code": "1201",
        "exact": true
      },
      {
        "path": "/performance_management/front_performance_dashboard",
        "name": "FrontDashBoard",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__PerformanceFrontDashboard' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/PerformanceFrontDashboard'), loading: LoadingComponent}),
        "code": "1207",
        "exact": true
      },
      {
        "path": "/performance_management/performance_list",
        "name": "绩效列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__PerformanceList' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/PerformanceList'), loading: LoadingComponent}),
        "code": "1202",
        "exact": true
      },
      {
        "path": "/performance_management/employee_list/:id",
        "name": "被考核人列表",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__EmployeeList' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/EmployeeList'), loading: LoadingComponent}),
        "code": [
          "1202"
        ],
        "exact": true
      },
      {
        "path": "/performance_management/my_performance",
        "name": "我的绩效",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__MyPerformance' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/MyPerformance'), loading: LoadingComponent}),
        "code": "1203",
        "exact": true
      },
      {
        "path": "/performance_management/team_performance",
        "name": "团队绩效",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PerformanceManagement__TeamPerformance' */'/builds/msfund/msvc-web/src/pages/PerformanceManagement/TeamPerformance'), loading: LoadingComponent}),
        "code": "1204",
        "exact": true
      },
      {
        "path": "/performance_management/my_archive",
        "name": "我的档案",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HrManagement__EmployeeArchive__ArchiveDetail__myArchive' */'/builds/msfund/msvc-web/src/pages/HrManagement/EmployeeArchive/ArchiveDetail/myArchive'), loading: LoadingComponent}),
        "code": "1206",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/builds/msfund/msvc-web/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/builds/msfund/msvc-web/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
